var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71484 12.541C2.71484 8.77002 2.71484 6.88402 3.88684 5.71302C5.05884 4.54202 6.94384 4.54102 10.7148 4.54102H14.7148C18.4858 4.54102 20.3718 4.54102 21.5428 5.71302C22.7138 6.88502 22.7148 8.77002 22.7148 12.541C22.7148 16.312 22.7148 18.198 21.5428 19.369C20.3708 20.54 18.4858 20.541 14.7148 20.541H10.7148C6.94384 20.541 5.05784 20.541 3.88684 19.369C2.71584 18.197 2.71484 16.312 2.71484 12.541Z",
    stroke: "#363636",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7148 16.541H6.71484M14.7148 16.541H13.2148M2.71484 10.541H22.7148",
    stroke: "#363636",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/icon-credit-card.2bd7ed5103e6178c506cd753e3d82f89.svg";
export { ForwardRef as ReactComponent };